import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchInfoHeaderComponent',
  props: {
  title: {
    type: String as PropType<string>,
    required: true
  },
  subtitle: {
    type: String as PropType<string>,
    required: false
  },
  icon: {
    type: String as PropType<string>,
    required: false
  }
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

})